import { render } from "./MainListSales.vue?vue&type=template&id=56fe46c2&scoped=true"
import script from "./MainListSales.vue?vue&type=script&lang=js"
export * from "./MainListSales.vue?vue&type=script&lang=js"

import "./MainListSales.vue?vue&type=style&index=0&id=56fe46c2&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe46c2"]])

export default __exports__